import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Footer as BaseFooter } from '@singtel-web/widgets';
import useIsWebViewFlow from '../../hooks/useIsWebViewFlow';

const Footer = () => {
  const { isClient, isWebView, flow } = useIsWebViewFlow();
  if (!isClient || (isClient && isWebView)) return null;

  return (
    <StaticQuery
      flow={flow}
      query={graphql`
        {
          singtelFooter {
            copyrightText
            minimalLinks {
              href
              text
            }
          }
        }
      `}
      render={data => {
        const { minimalLinks, copyrightText } = data.singtelFooter;

        return (
          <BaseFooter
            baseUrl="https://www.singtel.com"
            minimalLinks={minimalLinks}
            copyrightText={copyrightText}
          />
        );
      }}
    />
  );
};

export default Footer;
